"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react');


var _useBus = require('shared/hooks/useBus'); var _useBus2 = _interopRequireDefault(_useBus);
var _utils = require('shared/hooks/inbox/useInbox/utils');


// Calls onRemoved when you lose access to this chat while it's open, e.g.
// someone removes you from it. The store drops the chat at the same time, so
// the screen showing it has nothing left to render.
 const useOnRemovedFromChat = (blobjectKey, onRemoved) => {
  const handlePurge = _react.useCallback.call(void 0, 
    (p) => {
      // SAFETY: the bus only calls this for purgeActions.
      if (_optionalChain([(p ), 'access', _ => _.payload, 'optionalAccess', _2 => _2.Blobjects, 'optionalAccess', _3 => _3.includes, 'call', _4 => _4(blobjectKey)])) onRemoved()
    },
    [blobjectKey, onRemoved],
  )
  _useBus2.default.call(void 0, _utils.purgeActions, handlePurge)
}; exports.useOnRemovedFromChat = useOnRemovedFromChat
